/**
 * Component: Site selector
 */


var ed = ed || {};

ed.riskModel = new function(){
    /**
     * Init function
     */
    this.init = function() {
        $('body').click(function(e) {
            if ($(e.target).closest('.risk-model-list-box--active').length === 0) {
                removeAllActiveBoxes();
            }
        });

        $('.risk-model-list-box').each(function(){
            $(this).on('click', function(){

                if($(this).hasClass('risk-model-list-box--active')) {
                    // Close the active box
                    $(this).removeClass('risk-model-list-box--active');
                }
                else {
                    // Start by removing all active classes
                    removeAllActiveBoxes();

                    // Set the active box
                    $(this).addClass('risk-model-list-box--active');
                }
            });
        });

    };

    function removeAllActiveBoxes() {
        $('.risk-model-list-box--active').each(function(){
            $(this).removeClass('risk-model-list-box--active');
        });
    }
};
